(() => {
  const sectionSelector = '.featured-multi-collection';

  function initSection(section) {
    if (section.dataset.multiCollectionItemsInitialized === 'true') return;

    const toggles = Array.from(section.querySelectorAll('.collection-toggle'));
    const sliders = Array.from(section.querySelectorAll('.multi-collecton-items'));
    if (!toggles.length || toggles.length !== sliders.length) return;

    section.dataset.multiCollectionItemsInitialized = 'true';
    toggles.forEach((toggle, index) => {
      toggle.addEventListener('click', () => {
        sliders.forEach((slider, sliderIndex) => {
          slider.classList.toggle('active', sliderIndex === index);
        });
      });
    });
  }

  function init(root = document) {
    if (root.matches && root.matches(sectionSelector)) initSection(root);
    if (root.querySelectorAll) root.querySelectorAll(sectionSelector).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
